import React from 'react';
import bowser from 'yola-bowser';
import PropTypes from 'prop-types';
import Box from '../box';
import { PADDING_PROP_TYPES } from '../box/constants';

const DialogHeader = ({
  children,
  paddingTop = null,
  paddingBottom = null,
  paddingLeft = null,
  paddingRight = null,
}) => {
  const isMobile = bowser.mobile;
  const boxProps = {
    paddingTop: paddingTop || 'spacing-2-xs',
    paddingBottom: paddingBottom || 'spacing-2-xs',
    paddingLeft: paddingLeft || isMobile ? 'spacing-xs' : 'spacing-m',
    paddingRight: paddingRight || isMobile ? 'spacing-xs' : 'spacing-m',
  };

  return (
    <div className="ws-ui-dialog-header">
      <Box {...boxProps}>
        <div className="ws-ui-dialog-header__content">{children}</div>
      </Box>
    </div>
  );
};

DialogHeader.propTypes = {
  children: PropTypes.node.isRequired,
  paddingTop: PADDING_PROP_TYPES.paddingTop,
  paddingBottom: PADDING_PROP_TYPES.paddingBottom,
  paddingLeft: PADDING_PROP_TYPES.paddingLeft,
  paddingRight: PADDING_PROP_TYPES.paddingRight,
};

export default DialogHeader;
